/**
 * Memoized getArtists snapshot — one fetch per catalog revision, not per tab entry.
 */

export type ArtistCatalogMap = Record<string, Record<string, unknown>>;

let cachedRevision = '';
let cachedMap: ArtistCatalogMap | null = null;
let inFlight: Promise<ArtistCatalogMap> | null = null;

export async function getArtistCatalogMapCached(
  catalogRevision: string,
  fetchMap: () => Promise<ArtistCatalogMap>,
): Promise<ArtistCatalogMap> {
  const rev = String(catalogRevision ?? '');
  if (cachedRevision === rev && cachedMap) {
    return cachedMap;
  }
  if (cachedRevision === rev && inFlight) {
    return inFlight;
  }

  cachedRevision = rev;
  inFlight = fetchMap()
    .then((map) => {
      cachedMap = map;
      inFlight = null;
      return map;
    })
    .catch((err) => {
      if (cachedRevision === rev) {
        cachedRevision = '';
        cachedMap = null;
      }
      inFlight = null;
      throw err;
    });

  return inFlight;
}

export function peekArtistCatalogMapCached(catalogRevision: string): ArtistCatalogMap | null {
  const rev = String(catalogRevision ?? '');
  if (cachedRevision === rev && cachedMap) return cachedMap;
  return null;
}

export function resetArtistEnrichmentCatalogCacheForTests(): void {
  cachedRevision = '';
  cachedMap = null;
  inFlight = null;
}
